import * as Yup from "yup";
import { forceInt } from "Utils";
import { transform as entryTransformer } from "./Entry";
import { transform as channelMetaTransformer } from "./ChannelMeta";

export const EntryMetaValidationSchema = Yup.object().shape({});

export const EntryMetaObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    slug: "",
    value: null,
    entry_id: null,
    channel_meta_id: null,
    created_at: null,
    modified_at: null,
    channelMeta: {},
    entry: null,
};

/**
 * Transform API object to a EntryMeta object
 * @param {object} requestData JSON object from the API
 * @returns Object
 */
export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let entryMeta = Object.assign({}, EntryMetaObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        slug: requestData.slug,
        value: requestData.value,
        entry_id: forceInt(requestData.entry_id),
        channel_meta_id: requestData.channel_meta_id,
        object_type: "entryMeta",
    });

    if (requestData.channelMeta) {
        let channelMeta = channelMetaTransformer(requestData.channelMeta);
        entryMeta = Object.assign({}, entryMeta, { channelMeta: channelMeta });
    }

    if (requestData.entry) {
        let entry = entryTransformer(requestData.entry);
        entryMeta = Object.assign({}, entryMeta, { entry: entry });
    }

    return entryMeta;
}

/**
 * Serialize the content object to a string
 * @param {object} item
 * @returns string
 */
export function serialize(item) {
    return JSON.stringify(item);
}

/**
 * Deserialize json string
 * @param {string} item
 * @returns object
 */
export function deserialize(item) {
    return JSON.parse(item);
}

/**
 *
 * @param {object} item The object being saved
 * @param {object} resetVars Values to overwrite after preparation
 * @returns Object
 */
export function prepare(item, resetVars = {}) {
    return Object.assign(
        {},
        item,
        {
            object_type: undefined,
        },
        resetVars
    );
}
